import { HeaderContext, SortingFnOption } from '@tanstack/react-table'

export const genericSorting = <T,>(
  sortingFn: SortingFnOption<T>,
  label: string | JSX.Element,
  sortDescFirst: boolean = false,
) => {
  return {
    sortingFn,
    sortDescFirst,
    sortUndefined: 'last' as false | -1 | 1 | 'first' | 'last',
    header: ({ column }: HeaderContext<T, unknown>) => (
      <span className='cursor-pointer' onClick={() => column.toggleSorting()}>
        {label}
      </span>
    ),
  }
}
